import { useState, useEffect } from "react";
import {
  OutLinedHoverButton,
} from "../reusble_components/buttons/primaryButton";
import { useNavigate } from "react-router-dom";
import { toJS } from "mobx";
import { useStores } from "../../store";
import { interviewsProList } from "../../helpers/constantVariables";
import HelpCenter from "../reusble_components/helpCenter";
import ClientPopup from "./ClientPopup";
import VerifyPopup from "./Components/VerifyPopup";
import { IoIosLaptop } from "react-icons/io";
import { ImSortAmountAsc } from "react-icons/im";
import jobPostIcon from "../../assests/jobPostIcon.svg";
import hrInterviewIcon from "../../assests/svg/hrInterviewIcon.svg";
import mcqTestIcon from "../../assests/svg/mcqTestIcon.svg";
import {
  AiOutlineDollarCircle,
} from "react-icons/ai";
import { RiCustomerService2Line, RiRobot2Line } from "react-icons/ri";
import { IoClose } from "react-icons/io5";

const MinimalistPopup = ({ isOpen, onClose, title }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Backdrop */}
      <div
        className="fixed inset-0 bg-black/30 backdrop-blur-sm"
        onClick={onClose}
      />

      {/* Popup */}
      <div className="relative bg-white rounded-lg shadow-xl p-6 w-[90%] max-w-sm transform transition-all">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600"
        >
          <IoClose size={20} />
        </button>

        <div className="text-center">
          <div className="w-12 h-12 mx-auto mb-4 bg-primary/10 rounded-full flex items-center justify-center">
            <span className="text-2xl">✨</span>
          </div>

          <h3 className="text-lg font-medium text-gray-900 mb-2">
            Coming Soon
          </h3>

          <p className="text-sm text-gray-500 mb-4">
            {title} is currently in development
          </p>

          <button
            onClick={onClose}
            className="text-sm text-primary hover:text-primary/80 font-medium"
          >
            Got it
          </button>
        </div>
      </div>
    </div>
  );
};

// Feature Limit Modal
function FeatureLimitModal({ open, features, onUpgrade, onContinue, onClose }) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="bg-white rounded-lg shadow-xl p-6 w-[90%] max-w-md relative">
        <h2 className="text-xl font-bold mb-2 text-primary">Feature Limit Reached</h2>
        <p className="mb-4 text-gray-700">
          You've reached the limit of your current plan for the following services:
        </p>
        <ul className="mb-4 list-disc list-inside text-gray-800">
          {features.map((f) => (
            <li key={f}>{f === "Job Application" ? "Job Post" : f}</li>
          ))}
        </ul>
        <p className="mb-6 text-gray-700">
          To unlock more usage, please upgrade to the Pro Plan.
        </p>
        <div className="flex gap-3 justify-end">
          <button
            className="bg-primary text-white px-4 py-2 rounded hover:bg-primary/90"
            onClick={onUpgrade}
          >
            Upgrade to Pro
          </button>
          {/* <button
            className="bg-gray-200 text-gray-800 px-4 py-2 rounded hover:bg-gray-300"
            onClick={onContinue}
          >
            Continue
          </button> */}
        </div>
        <button
          className="absolute top-2 right-2 text-gray-400 hover:text-gray-600 text-2xl"
          onClick={onClose}
        >
          ×
        </button>
      </div>
    </div>
  );
}

// Feature limit check function
function checkFeatureLimits(subscription) {
  if (!subscription || !subscription.featureUsage) return [];
  return subscription.featureUsage
    .filter(
      (feature) =>
        typeof feature.limit === "number" &&
        typeof feature.usedCount === "number" &&
        feature.usedCount >= feature.limit
    )
    .map((feature) => feature.name);
}

// Helper to check if a feature is allowed
function isFeatureAllowed(featureName, featureUsage) {
  const feature = featureUsage.find(f => f.name === featureName);
  if (!feature || feature.limit === undefined) return true;
  return feature.usedCount < feature.limit;
}

const featureMap = {
  "job-post": "Job Application",
  "mcq": "MCQ Assessments",
  "resumeSort": "AI Resume Analyser",
  2: "AI Interviewer",
  8: "AI Interviewer",

  // add more if needed
};

export default function CreateNew() {
  return (
    <div className="w-full mt-[10%] md:mt-[3.2%]">
      <HelpCenter />
      <HeaderComponent tittle={"Services"} />
      <div className="w-[90%] mx-auto">
        <CreateJobPost />
      </div>
    </div>
  );
}

export function CreateJobPost() {
  const [isHoveredIndex, setIsHoveredIndex] = useState(null);
  const [popupState, setPopupState] = useState({ isOpen: false, title: "" });
  const [showLimitModal, setShowLimitModal] = useState(false);
  const [limitReachedFeatures, setLimitReachedFeatures] = useState([]);
  const navigate = useNavigate();
  const { InterviewStore, CommonStore, RecuiterStore, MockStore, PopupStore, UserStore } = useStores();
  const [interviewListWithModels, setInterviewListWithModels] = useState();
  const subscription = UserStore.previousSubscriptions;
  const interviews = [
    {
      id: "AiInterview",
      id2: "interview-form",
      title: " AI Interview Demo ",
      description:
        "Try our AI Interview demo to see how it asks questions, evaluates answers, and gives reports.",
      active: true,
      comingSoon: false,
      icon: (
        <p className="bg-black rounded-full flex items-center justify-center p-[10px] mb-3 h-11 w-11">
          <RiRobot2Line className="text-[50px] text-white" />
        </p>
      ),
    },
    {
      id: "job-post",
      id2: "job-post",
      title: "Job Post",
      description:
        "Easily create job posts, reach top talent, and streamline hiring with smart matching and customizable templates.",
      active: true,
      comingSoon: false,
      icon: (
        <span className="bg-black w-fit h-fit p-3 mb-3 rounded-full">
          <img src={jobPostIcon} className="text-white " alt="jobPostIcon" />
        </span>
      ),
    },
    {
      id: 2,
      id2: "technical-interview",
      title: "Technical Interview",
      description:
        "Conduct seamless technical interviews with our easy-to-use platform. Evaluate candidates effectively and streamline your hiring process. ",
      active: true,
      comingSoon: false,
      icon: (
        <IoIosLaptop className="text-3xl h-11 w-11 p-2 mb-3 bg-black text-white rounded-full " />
      ),
    },
    {
      id: 8,
      id2: "hr-interview",
      title: "HR Interview",
      description:
        "Conduct efficient HR interviews, evaluate candidates thoroughly, and streamline your hiring process effortlessly with our platform.",
      active: true,
      comingSoon: false,
      icon: (
        <span className="bg-black w-fit h-fit p-3 mb-3 rounded-full">
          <img
            src={hrInterviewIcon}
            className="text-white "
            alt="hrInterviewIcon"
          />
        </span>
      ),
    },
    {
      id: "mcq",
      id2: "mcq",
      title: "MCQ's Test",
      description:
        "Easily create and manage MCQs to assess candidate knowledge. Enhance your evaluation process with our intuitive and efficient platform. ",
      active: true,
      comingSoon: false,
      icon: (
        <span className="bg-black w-11 h-11 p-3 mb-3 rounded-full">
          <img src={mcqTestIcon} className="text-white " alt="jmcqTestIcon" />
        </span>
      ),
    },
    {
      id: "resumeSort",
      id2: "resume",
      title: "Resume Analyzer",
      description:
        "Simplify and streamline the resume review process. Automatically sort and analyze resumes to identify top candidates quickly and efficiently. ",
      active: true,
      comingSoon: false,
      icon: (
        <ImSortAmountAsc className="text-xl h-11 w-11 p-3 mb-3 bg-black text-white rounded-full  " />
      ),
    },
    {
      id: "Telephonic screening",
      id2: "Telephonic-screening",
      title: " Telephonic Screening ",
      description:
        "Efficient phone interviews to pre-qualify candidates, saving time and streamlining hiring.",
      active: true,
      comingSoon: true,
      icon: (
        <RiCustomerService2Line className="text-xl h-11 w-11 p-3 mb-3 bg-black text-white rounded-full  " />
      ),
    },
    {
      id: "Employee appraisal",
      id2: "Employee-appraisal",
      title: " Employee Appraisal ",
      description:
        "Simplified performance evaluations to assess, review, and improve employee productivity and growth.",
      active: true,
      comingSoon: true,
      icon: (
        <AiOutlineDollarCircle className="text-xl h-11 w-11 p-3 mb-3 bg-black text-white rounded-full  " />
      ),
    },
  ];

  const [pendingAction, setPendingAction] = useState(null);
  const [pendingActionParams, setPendingActionParams] = useState(null);

  // Handler to check limit for only the relevant feature
  const handleActionWithLimitCheck = (actionCallback, index, interview) => {
    const featureName = featureMap[interview.id];
    if (featureName && subscription && subscription.featureUsage) {
      if (!isFeatureAllowed(featureName, subscription.featureUsage)) {
        setLimitReachedFeatures([featureName]);
        setShowLimitModal(true);
        setPendingAction(() => () => actionCallback(index, interview.id, interview.id2));
        setPendingActionParams({ index, interview });
        return;
      }
    }
    actionCallback(index, interview.id, interview.id2);
  };

  const settingProInterview = (index, id, id2) => {
    // if (
    //   !JSON.parse(localStorage.getItem("user"))?.isAccountVerified
    // ) {
    //   PopupStore.setVerify(true);
    //   return;
    // }
    if (id === "AiInterview") {
      setInterviewListWithModels(interviewsProList);
      localStorage.setItem(
        "interviewSettings",
        JSON.stringify(interviewsProList[1])
      );
      const index1 = interviewsProList.findIndex(
        (interview) => interview.id === 2
      );
      console.log("this is index", index1);
      console.log("this is index", interviewsProList[index1]);
      InterviewStore.setInterviewSettings(interviewsProList[index1]);
      localStorage.setItem(
        "interviewIndex",
        JSON.stringify(interviewsProList[index1])
      );
      console.log("this is store", toJS(InterviewStore.interviewSettings));
      navigate("/company/meeting-creation-form");
      CommonStore.setCreateNewBack(true);
      return;
    }
    if (id === "createClient") {
      PopupStore.setClient(true);
      return;
    }
    RecuiterStore.ResetJobPostCustomSettings();
    CommonStore.setProgress(0);
    CommonStore.resetInterviewLabels();
    CommonStore.setLabelSkipped(1, false);
    CommonStore.setLabelSkipped(2, false);
    CommonStore.setLabelSkipped(3, false);
    if (id === "job-post") {
      // Reset job post data when creating new job post
      RecuiterStore.resetJobPostData();
      // Reset common store progress and labels
      CommonStore.setLabelActive(1, false);
      CommonStore.setLabelActive(2, false);
      CommonStore.setLabelActive(3, false);
      CommonStore.setLabelActive(4, false);
      CommonStore.setLabelActive(5, false);
      CommonStore.setLabelActive(6, false);
      CommonStore.setLabelActive(7, false);
      CommonStore.setProgress(0);
      RecuiterStore.jobPostDetails.basicJobDetails.salary.isSalaryDisclosed = true;
      console.log(
        "1",
        RecuiterStore.jobPostDetails.hrInterviewDetails.whoPayCheck
      );
      console.log(
        "2",
        RecuiterStore.jobPostDetails.technicalInterviewDetails.whoPayCheck
      );
      navigate(`/company/${id}`);
    } else if (id === "mcq") {
      MockStore.setMockTestInvitationLink(null);
      RecuiterStore.setMcqTestDetails("numberOfQuestions", "");
      RecuiterStore.setMcqTestDetails("cutOff", "");
      RecuiterStore.setMcqSections("questions", 0, null);
      RecuiterStore.setMcqSections("questions", 1, null);
      RecuiterStore.setMcqSections("questions", 2, null);
      RecuiterStore.setMcqSections("questions", 3, null);
      navigate(`/company/${id}`);
      CommonStore.setProgress(0);
    } else {
      // InterviewStore.setCompanyInterview(true);
      // setInterviewListWithModels(interviewsProList);
      // localStorage.setItem(
      //   "interviewSettings",
      //   JSON.stringify(interviewsProList[index])
      // );
      // const index1 = interviewsProList.findIndex(
      //   (interview) => interview.id === id
      // );
      // console.log("this is index", index1);
      // console.log("this is index", interviewsProList[index1]);
      // InterviewStore.setInterviewSettings(interviewsProList[index1]);
      // console.log("this is store", toJS(InterviewStore.interviewSettings));
      // navigate("/company/interview-form");
      // CommonStore.setCreateNewBack(true);
      RecuiterStore.setTechnicalInterviewDetails("skipped", false);
      RecuiterStore.setTechnicalInterviewDetails("technicalInterviewType", "");
      RecuiterStore.setTechnicalInterviewDetails(
        "technicalInterviewLevel",
        "low"
      );
      RecuiterStore.setTechnicalInterviewDetails("resumeCutoff", "");
      RecuiterStore.setTechnicalInterviewDetails("technology", "");
      RecuiterStore.setTechnicalInterviewDetails(
        "technicalNumberOfQuestions",
        ""
      );
      RecuiterStore.setTechnicalInterviewDetails("interviewId", null);
      RecuiterStore.setTechnicalInterviewDetails(
        "technicalCustomquestions",
        []
      );
      RecuiterStore.settechnicalAdditionalSettings("camera", false);
      RecuiterStore.settechnicalAdditionalSettings("screen", false);
      RecuiterStore.settechnicalAdditionalSettings("resume", false);
      RecuiterStore.settechnicalAdditionalSettings("attempts", 2);
      RecuiterStore.setHrInterviewDetails("skipped", false);
      RecuiterStore.setHrInterviewDetails("interviewType", "");
      RecuiterStore.setHrInterviewDetails("interviewLevel", "");
      RecuiterStore.setHrInterviewDetails("numberOfQuestions", null);
      RecuiterStore.setHrInterviewDetails("customquestions", []);
      RecuiterStore.setHrInterviewDetails("interviewId", null);
      RecuiterStore.setHrInterviewDetails("resumeCutoff", "");
      RecuiterStore.sethrAdditionalSettings("camera", false);
      RecuiterStore.sethrAdditionalSettings("screen", false);
      RecuiterStore.sethrAdditionalSettings("resume", false);
      RecuiterStore.sethrAdditionalSettings("attempts", 2);

      if (id === "resumeSort") {
        navigate(`/company/resume`);
        return;
      }

      navigate(`/company/${id2}`);
    }
  };

  return (
    <div className="w-full h-auto">
      <ClientPopup data={true} />
      <VerifyPopup />
      <MinimalistPopup
        isOpen={popupState.isOpen}
        onClose={() => setPopupState({ isOpen: false, title: "" })}
        title={popupState.title}
      />
      <FeatureLimitModal
        open={showLimitModal}
        features={limitReachedFeatures}
        onUpgrade={() => {
          setShowLimitModal(false);
          navigate("/company/subscription");
        }}
        onContinue={() => {
          setShowLimitModal(false);
          if (pendingAction && pendingActionParams) {
            pendingAction(pendingActionParams.index, pendingActionParams.interview);
            setPendingAction(null);
            setPendingActionParams(null);
          }
        }}
        onClose={() => {
          setShowLimitModal(false);
        }}
      />
      {/* services card section */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 2xl:grid-cols-3 gap-4 w-full mt-8 mb-8">
        {interviews.map((interview, index) => (
          <div
            onMouseEnter={() => setIsHoveredIndex(index)}
            onMouseLeave={() => setIsHoveredIndex(null)}
            key={index}
            className={`w-full h-[250px] bg-white rounded-xl p-6 flex flex-col
              ${
                interview.active
                  ? "hover:border-primary transition-all duration-300 hover:scale-105"
                  : "hover:border-[#C1C1C1]"
              }
              ${
                interview.id === "AiInterview"
                  ? "relative before:absolute before:inset-0 before:-z-10 before:animate-border-glow before:bg-gradient-conic before:rounded-xl before:p-[3px] before:opacity-0 before:opacity-10"
                  : ""
              }`}
            style={
              interview.id === "AiInterview"
                ? { background: "white" }
                : { boxShadow: "0px 0px 60px 7px rgba(0,0,0,0.07)" }
            }
          >
            <div className="flex items-center gap-3 mb-3">
              {interview.icon}
              <h1 className="text-lg font-semibold">{interview?.title}</h1>
            </div>

            <p className="text-sm text-text_color4 mb-4 flex-grow">
              {interview?.description}
            </p>

            <div className="mt-auto">
              <OutLinedHoverButton
                buttonName={
                  interview.comingSoon
                    ? "Coming Soon"
                    : interview.id === "AiInterview"
                    ? "Try Now"
                    : "Create New"
                }
                borderColor={isHoveredIndex === index ? "primary" : "black"}
                textColor={isHoveredIndex === index ? "primary" : "black"}
                onClick={() => {
                  if (interview.comingSoon) {
                    setPopupState({ isOpen: true, title: interview.title });
                    return;
                  }
                  handleActionWithLimitCheck(settingProInterview, index, interview);
                }}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export function HeaderComponent({ tittle }) {
  return (
    <div className="flex flex-col md:flex-row justify-between gap-y-4  md:flex w-[95%]">
      {/* <h1 className="text-3xl md:text-3xl font-bold text-primary  md:text-start block">
        {tittle}
      </h1> */}
      {/* <div className="flex justify-between items-center w-[90%] md:w-[70%] mx-[5%] p-2 bg-white rounded-full shadow-2xl shadow-slate-200">
        <input
          type="text"
          placeholder="Search by Name, Role or Technology"
          className=" placeholder-gray-400 p-4 truncate text-lg outline-none h-10 w-[88%] md:w-[90%] mx-auto"
        />
        <CiSearch className="text-4xl text-primary flex md:w-[5%] mx-auto" />
      </div> */}
    </div>
  );
}
